import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import sha256 from 'crypto-js/sha256';
import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';

export const authLogin = createAsyncThunk('user/login', async ({ username, password }, { rejectWithValue }) => {
    try {
        // configure header's Content-Type as JSON
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const encryptedPwd = sha256(password).toString(CryptoJS.enc.Hex);

        const { data } = await axios.post('/api/auth/login/', { username, password: encryptedPwd }, config);
        if (data.status === 200) {
            // store user's token in local storage
            localStorage.setItem('userToken', data.token);
            return data;
        } else {
            toast.error('Invalid credentials');
        }
    } catch (error) {
        // return custom error message from API if any
        if (error.response.status === 404) {
            toast.error('Invalid credentials');
            return rejectWithValue(error.response.data.message);
        } else if (error.response.status === 401) {
            toast.error("You haven't validated your account yet");
            return rejectWithValue(error.response.data.message);
        } else if (error.response.status === 403) {
            toast.error('Your account has been locked!');
            return rejectWithValue(error.response.data.message);
        } else if (error.response.status === 500) {
            toast.error('Server Error!');
            return rejectWithValue(error.response.data.message);
        } else {
            toast.error('Invalid credentials');
            return rejectWithValue(error.response.data.message);
        }
    }
});

// export const registerUser = createAsyncThunk(
//   'user/register',
//   async ({ firstName, email, password }, { rejectWithValue }) => {
//     try {
//       const config = {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       }

//       await axios.post(
//         '/api/user/register',
//         { firstName, email, password },
//         config
//       )
//     } catch (error) {
//       if (error.response && error.response.data.message) {
//         return rejectWithValue(error.response.data.message)
//       } else {
//         return rejectWithValue(error.message)
//       }
//     }
//   }
// )

export const getUserDetails = createAsyncThunk('user/getUserDetails', async (arg, { getState, rejectWithValue }) => {
    try {
        // get user data from store
        const { auth } = getState();

        // configure authorization header with user's token
        const config = {
            headers: {
                Authorization: `Token ${auth.userToken}`
            }
        };

        const { data } = await axios.get('/api/auth/user/', config);
        return data;
    } catch (error) {
        // toast.error('Your authentication has expired, please login again.');
        return rejectWithValue(error.response);
    }
});
